//imageCache.js
export class ImageCache {
  constructor(onLoad) {
    this.map = new Map();
    this.onLoad = onLoad;
  }

  load(src) {
    if (this.map.has(src)) {
      return this.map.get(src);
    }

    const img = new Image();
    img.decoding = 'async';
    img.loading = 'eager';

    const record = {
      img,
      ready: false,
      error: false,
      w: 0,
      h: 0,
    };

    img.addEventListener(
      'load',
      () => {
        record.ready = true;
        record.w = img.naturalWidth;
        record.h = img.naturalHeight;
        this.onLoad?.();
      },
      { once: true },
    );

    img.addEventListener(
      'error',
      () => {
        record.error = true;
        this.onLoad?.();
      },
      { once: true },
    );

    img.src = src;

    this.map.set(src, record);
    return record;
  }
}
